import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { BadgePill } from 'src/Admin/components/common/Badge';
import Avatar from 'src/Admin/components/common/avatar-with-initials';
import { ParaRegular } from 'src/Admin/components/common/typography/ParaRegular';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from 'src/Admin/img/findcare/FindCareSVG';

const LabelValueRow = ({ label, value }) => {
  return (
    <Col md={12} className="label-value-row">
      <Row className="p-0 m-0">
        <Col md={6} className="p-0">
          <ParaRegular>{label}</ParaRegular>
        </Col>
        <Col md={6} className="p-0">
          <ParaRegular variant={'large'}>{value}</ParaRegular>
        </Col>
      </Row>
    </Col>
  );
};

export const MemberDependentInfo = ({
  activeToggleId,
  setActiveToggleId,
  themeValuesObject,
  eventKey,
}) => {
  return (
    <Card
      className={
        eventKey === 'member-info'
          ? 'member-info-accordion main-member-block'
          : 'member-info-accordion'
      }
    >
      <Accordion.Toggle
        as={Card.Header}
        variant="link"
        eventKey={eventKey}
        onClick={() => {
          activeToggleId !== eventKey
            ? setActiveToggleId(eventKey)
            : setActiveToggleId(null);
        }}
        className="m-0"
      >
        <Row>
          <Col md={10} className="d-flex align-items-center">
            <span className="accordion-arrow">
              {activeToggleId === 'member-info' ? (
                <AccordionUpArrow
                  className="acc-arrow"
                  fillColor={themeValuesObject['Secondary-Grey']}
                />
              ) : (
                <AccordionDownArrow
                  className="acc-arrow"
                  fillColor={themeValuesObject['Secondary-Grey']}
                />
              )}{' '}
            </span>
            <Avatar fname={'jatin'} lname={'sharma'} />
            <div className="name-block">
              <h4 className="member-name">Brown, Edward</h4>
              <p className="common-label">Son</p>
            </div>
          </Col>
          <Col
            md={2}
            className={'d-flex align-items-center pr-0 justify-content-end'}
          >
            <BadgePill text={'UPDATED'} />
          </Col>
        </Row>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body className="p-0 m-0">
          <div className="content-box">
            <Row className="m-0">
              <Col md={6} className="pl-0 left-side-box">
                <LabelValueRow label={'Member ID'} value={'7541240'} />
                <LabelValueRow label={'Date of Birth'} value={'03-07-1969'} />
                <LabelValueRow label={'Gender'} value={'Female'} />

                <LabelValueRow label={'Race/ Ethnicity'} value={'Other'} />
                <LabelValueRow label={'Martital Status'} value={'Married'} />
              </Col>
              <Col md={6} className="pr-0">
                <LabelValueRow label={'Age'} value={'49 years'} />
                <LabelValueRow
                  label={'Social Security Number'}
                  value={'xxx-xx-2316'}
                />
                <LabelValueRow label={'Alternative ID 1'} value={'N/A'} />
                <LabelValueRow label={'Alternative ID 2'} value={'N/A'} />
              </Col>
            </Row>
          </div>
          <div className="content-box thicker-border-bottom">
            <Row className="m-0">
              <Col md={6} className="pl-0 left-side-box">
                <LabelValueRow label={'Email'} value={'janeB@gmail.com'} />
                <LabelValueRow
                  label={'Alternative Email'}
                  value={'janbrown@gmail.com'}
                />
                <LabelValueRow
                  label={'Home Phone'}
                  value={'+1 (201) 323 3233'}
                />
                <LabelValueRow label={'Work Home'} value={'N/A'} />
              </Col>
              <Col md={6} className="pr-0">
                <LabelValueRow
                  label={'Residential Address'}
                  value={'495 Grove Street Apartment #20 New York, NY 10014'}
                />
                <LabelValueRow
                  label={'Mailing Address'}
                  value={'495 Grove Street Apartment #20 New York, NY 10014'}
                />
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};
